<template>
	<div class="contain pad-x pt-32 lg-pt-44 pb-72 lg-pb-96 bg-gradient">
		<div class="flex-split wrap gap-16 mb-24 lg-mb-28">
			<h1 class="mb-0 fs-26 lg-fs-32 fw-800">Messages</h1>
			<div class="show-md rel">
				<svg class="block abs-center-y left-16" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
					<path stroke="#140047" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M9.063 15.625a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125ZM13.703 13.703 17.5 17.5"/>
				</svg>
				<input type="search" v-model="searchInput" placeholder="Search messages" class="fs-16 lh-16 pl-52" style="padding-top:18px;padding-bottom:14px;" @keyup="search">
			</div>
		</div>
		<div class="account-layout mt-24">
			<aside>
				<nav class="account-nav card-v2">
					<button @click="updateStatus('Active')" :class="{ 'is-active': filters.status == 'Active'}">Active</button>
					<button @click="updateStatus('Archived')" :class="{ 'is-active': filters.status == 'Archived'}">Archived</button>
				</nav>
				<div class="rel hide-md mt-24">
					<svg class="block abs-center-y left-16" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
						<path stroke="#140047" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M9.063 15.625a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125ZM13.703 13.703 17.5 17.5"/>
					</svg>
					<input type="search" v-model="searchInput" placeholder="Search messages" class="fs-16 lh-16 pl-52" style="padding-top:18px;padding-bottom:14px;" @keyup="search">
				</div>
			</aside>
			<main>
				<div class="card-v2 lg-px-16" ref="card">
					<div v-if="errorMessage" class="error-message">
						{{ errorMessage }}
					</div>
					<div v-else-if="!items.length & !isLoading" class="pad-24 flex-center color-violet fs-16 border bg-violet-01 fw-700">
						There are no messages to show.
					</div>
					<table v-else :class="{ 'pointer-events-none op-6': isFiltering }" class="messages-table rel">
						<colgroup>
							<col/>
							<col/>
							<col/>
							<col/>
						</colgroup>
						<thead class="fw-500 fs-14 color-violet">
							<th class="fw-500 pb-16">
								<div class="flex gap-8">
									User
									<OrderButton :active="filters.sortBy == 'userName'" :order="filters.sortOrder" @click.native="reOrder('userName')"/>
								</div> 
							</th>
							<th class="fw-500 pb-16">
								<div class="flex gap-8">
									Job Name
									<OrderButton :active="filters.sortBy == 'eventName'" :order="filters.sortOrder" @click.native="reOrder('eventName')"/>
								</div>
							</th>
							<th class="fw-500 pb-16 text-left">Message</th>
							<th class="fw-500 pb-16">
								<div class="flex gap-8 justify-end">
									Date
									<OrderButton :active="filters.sortBy == 'lastMessageDate'" :order="filters.sortOrder" @click.native="reOrder('lastMessageDate')"/>
								</div>
							</th>
						</thead>
						<!-- <thead class="fw-500 fs-14 color-violet sticky">
							<th class="fw-500 pb-16">
								<div class="flex gap-8">
									User
									<OrderButton :active="filters.sortBy == 'userName'" :order="filters.sortOrder" @click.native="reOrder('userName')"/>
								</div> 
							</th>
							<th class="fw-500 pb-16">
								<div class="flex gap-8">
									Job Name
									<OrderButton :active="filters.sortBy == 'eventName'" :order="filters.sortOrder" @click.native="reOrder('eventName')"/>
								</div>
							</th>
							<th class="fw-500 pb-16 text-left">Message</th>
							<th class="fw-500 pb-16">
								<div class="flex gap-8 justify-end">
									Date
									<OrderButton :active="filters.sortBy == 'lastMessageDate'" :order="filters.sortOrder" @click.native="reOrder('lastMessageDate')"/>
								</div>
							</th>
						</thead> -->
						<tbody>
							<tr v-for="item in items" :key="item.chat.id" :class="{ 'no-hover': chatRequiresUpgrade(item) }" class="cursor-pointer rel" @click="toThread(item)">
									<td class="user">
										<div v-if="!item.chatUserProfile || chatRequiresUpgrade(item)" class="flex gap-16">
											<div class="square-40 round bg-studio flex-center">
												<svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" fill="none" viewBox="0 0 13 12"><path stroke="#ED2644" stroke-width="1.5" d="M6.34336 8.0501C8.28936 8.0501 9.86836 6.4719 9.86836 4.525C9.86836 2.5782 8.28936 1 6.34336 1C4.39636 1 2.81836 2.5782 2.81836 4.525C2.81836 6.4719 4.39636 8.0501 6.34336 8.0501Z" clip-rule="evenodd"/><path stroke="#ED2644" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M1 11.1347C1.541 10.197 2.32 9.41838 3.258 8.87698C4.196 8.33568 5.26 8.05068 6.343 8.05078C7.426 8.05078 8.49 8.33578 9.428 8.87708C10.366 9.41848 11.145 10.1971 11.686 11.1348"/></svg>
											</div>
											<div class="color-violet fw-500 name hover-underline">Studio</div>
										</div>
										<div v-else class="flex gap-16">
											<ProfileAvatar :profile="item.chatUserProfile" size="40" class="square-40" @click.stop/>
											<router-link :to="{ name: $routes.Profile.name, params: { id: item.chatUserProfile.id }}" class="color-violet fw-500 name hover-underline" @click.stop>{{ item.chatUserProfile.name }}</router-link>
										</div>
									</td>
									<td class="job">
										<div class="fs-14 fw-700 color-violet">{{ item.job.event.name }}</div>
									</td>
									<td class="message">
										<div v-if="chatRequiresUpgrade(item)" class="truncate fs-14">
											<UpgradeButton class="button-inline fs-14 fw-500 color-blue" :job="item.job" @click.native.stop>Upgrade your account</UpgradeButton> to read message.
										</div>
										<div v-else-if="filters.keyword && 'matchedKeywordMessage' in item" class="truncate" v-html="highlightText(stripTags(item.matchedKeywordMessage.content.text))"></div>
										<div v-else class="truncate">{{ stripTags(item.lastMessage.content.text) }}</div>
									</td>
								<td class="date">
									<div class="flex justify-end gap-12">
										<div v-if="item.unreadMessagesCount" class="unread-messages-count">
											{{ item.unreadMessagesCount }}
										</div>
										<span v-if="'matchedKeywordMessage' in item">
											{{ formatMessageTime(item.matchedKeywordMessage.createdAt) }}
										</span>
										<span v-else>
											{{ formatMessageTime(item.lastMessage.createdAt) }}
										</span>
									</div>
								</td>
							</tr>

							<template v-if="isLoading && numberToLoad > 0">
								<tr v-for="index in numberToLoad" class="no-hover" :key="index">
									<td style="border:0;">
										<div class="flex gap-16">
											<div class="skeleton square-40 round"></div>
											<div class="skeleton pt-16" style="width:125px;max-width:100%"></div>
										</div>
									</td>
									<td style="border:0;">
										<div class="skeleton pt-16" style="width:180px;max-width:100%"></div>
									</td>
									<td style="border:0;">
										<div class="skeleton pt-16" style="width:300px;max-width:100%"></div>
									</td>
									<td style="border:0;">
										<div class="flex-right">
											<div class="skeleton pt-16" style="width:60px;max-width:100%"></div>
										</div>
									</td>
								</tr>
							</template>
						</tbody>
					</table>
				</div>
			</main>
		</div>
	</div>
</template>

<script>
import OrderButton from '@/components/OrderButton.vue';
import { fetchChats } from '@/services/swm/api';
import { formatMessageTime, stripTags } from '@/helpers/format';
import { chatRequiresUpgrade } from '@/helpers/flags';

export default {
	name: 'Messages',
	components: { OrderButton },
	data() {
		return {
			items: [],
			init: false,
			isLoading: false,
			isFiltering: false,
			errorMessage: null,
			searchTimeout: null,
			searchInput: '',
			canLoadMore: false,
			meta: {
				total: 10,
			},
			filters: {
				keyword: '',
				status: 'Active',
				sortBy: 'lastMessageDate',
				sortOrder: 'desc',
				limit: 10,
				offset: 0,
			}
		}
	},
	computed: {
		numberToLoad() {
			const leftToFetch = this.meta.total - this.items.length;
			return leftToFetch < this.filters.limit ? leftToFetch : this.filters.limit;
		},
		freeJob() {
			return this.$store.getters['jobs/freeJobData'].freeJob;
		},
		subscription() {
			return this.$store.getters['subscriptions/current'];
		},
		isTrialing() {
			return !!this.subscription?.isTrialing;
		},
	},
	methods: {
		formatMessageTime,
		stripTags,
		chatRequiresUpgrade,
		highlightText(text) {
			const toHighlight = this.filters.keyword;
			return text.replace(new RegExp("(" + toHighlight + ")", "gi"), '<span class="highlight"><span class="rel z-2 color-violet">$1</span></span>');
		},
		async fetchData() {
			// Show skeleton rows if initial page load or loading more rows
			// Otherwise we're filtering and lower opacity on current rows
			if (this.filters.offset > 0 || !this.init) {
				this.isLoading = true;
				
			} else {
				this.isFiltering = true;
			}

			this.errorMessage = null;
			
			try {
				const { data, meta } = await fetchChats(this.filters);
				this.meta = meta;
				
				if (this.filters.offset > 0) {
					this.items = this.items.concat(data);
				} else {
					this.items = data;
				}

				this.canLoadMore = this.items.length < this.meta.total;

				this.isLoading = false;
				this.isFiltering= false;
				this.init = true;
				
				// If initial page load has no scroll but we have more to load...
				this.checkLoadMore();
			} catch (error) {
				console.log('@@ fetchChats error', error);
				this.errorMessage = 'Error loading messages';
				this.isLoading = false;
				this.isFiltering= false;
				this.init = true;
			}
		},
		reOrder(sortBy) {
			this.filters.offset = 0;
			if (sortBy == this.filters.sortBy) {
				this.filters.sortOrder = this.filters.sortOrder == 'asc' ? 'desc' : 'asc';
			} else {
				this.filters.sortBy = sortBy;
			}
		},
		toThread(item) {
			if (this.chatRequiresUpgrade(item)) {
				return;
			}
			
			const params = {
				chatId: item.chat.id,
				jobId: item.job.id
			};

			this.$router.push({name: 'thread', params});
		},
		search() {
			clearTimeout(this.searchTimeout);
			
			this.searchTimeout = setTimeout(() => {
				this.filters.offset = 0;
				this.filters.keyword = this.searchInput.trim().length > 2
					? this.searchInput.trim()
					: '';
			}, 300);
		},
		checkLoadMore() {
			const card = document.querySelector('main');
			const topOfCard = card.getBoundingClientRect().top + window.scrollY;
			const viewBottom = window.innerHeight + window.scrollY;
			const shouldLoadMore = viewBottom >= topOfCard + card.offsetHeight;
			
			if (shouldLoadMore && this.canLoadMore) {
				this.canLoadMore = false; // prevent this from firing again until after we fetch more
				this.filters.offset += this.filters.limit;
			}
		},
		updateStatus(value) {
			this.items = [];
			this.filters.offset = 0;
			this.filters.status = value;
			this.meta.total = 10;
			this.init = false;
		},
	},
	mounted() {
		window.addEventListener('scroll', this.checkLoadMore);
		this.$store.commit('cache/setPreviousRoute', 'messages');
	},
	metaInfo: {
		title: 'Messages',
	},
	watch: {
		filters: {
			handler() {
				this.fetchData();
			},
			deep: true,
			immediate: true,
		}
	}
};
</script>
